import { all } from 'redux-saga/effects';

import dialogs from './dialogs';

function* watch() {
  yield all([dialogs.saga.watch()]);
}

export default {
  watch,
};
